export const C = {
    teal: '#1D9E75',
    tealL: '#E1F5EE',
    coral: '#D85A30',
    coralL: '#FAECE7',
    blue: '#185FA5',
    blueL: '#E6F1FB',
    amber: '#BA7517',
    amberL: '#FAEEDA',
    purple: '#534AB7',
    purpleL: '#EEEDFE',
    green: '#1A7A4A',
    greenL: '#E2F5EC',
    ink: 'var(--cg-text)',
    mist: 'var(--cg-mist)',
    border: 'var(--cg-border)',
    border2: 'var(--cg-border-strong)',
    surface: 'var(--cg-surface)',
    surfaceAlt: 'var(--cg-surface-alt)',
    surfaceRaised: 'var(--cg-surface-raised)',
    textMuted: 'var(--cg-text-muted)',
    textSoft: 'var(--cg-text-soft)',
    textFaint: 'var(--cg-text-faint)',
    shadow: 'var(--cg-shadow)',
};

export const PRODUCT_CATALOG = [
    {
        id: 'demo-1',
        sku: 'DEMO-001',
        name: 'Classic Cotton T-Shirt',
        category: 'Apparel',
        topic: '{{vendor}} {{UPPER(product_name)}} — comfortable everyday wear',
        fields: [
            // {field: 'Key benefit', kw: 'soft, breathable, all-day comfort'},
            // {field: 'Material', kw: '100% organic cotton'},
            // {field: 'Design style', kw: 'minimalist, versatile'},
            // {field: 'Price point', kw: '{{price}} — premium basics'},
            // {field: 'Ideal for', kw: 'casual wear, layering, everyday'},
        ],
    },
    {
        id: 'demo-2',
        sku: 'DEMO-002',
        name: 'Leather Crossbody Bag',
        category: 'Accessories',
        topic: '{{vendor}} Leather Crossbody — {{product_type}} essential',
        fields: [
            // {field: 'Key benefit', kw: 'hands-free, organized, stylish'},
            // {field: 'Material', kw: 'full-grain leather'},
            // {field: 'Design style', kw: 'modern, compact'},
            // {field: 'Price point', kw: '{{price}} — everyday luxury'},
            // {field: 'Ideal for', kw: 'travel, commute, going out'},
        ],
    },
    {
        id: 'demo-3',
        sku: 'DEMO-003',
        name: 'Ceramic Pour-Over Set',
        category: 'Home & Kitchen',
        topic: '{{vendor}} Pour-Over Set — artisan {{product_type}}',
        fields: [
            // {field: 'Key benefit', kw: 'rich flavor, manual brew, ritual'},
            // {field: 'Material', kw: 'hand-glazed ceramic'},
            // {field: 'Design style', kw: 'artisan, Scandinavian'},
            // {field: 'Price point', kw: '{{price}} — gift-ready'},
            // {field: 'Ideal for', kw: 'coffee lovers, home baristas'},
        ],
    },
];

export const PRODUCT_CATEGORIES = [...new Set(PRODUCT_CATALOG.map((product) => product.category))];

export const DEFAULT_VARS = [
    {id: 'v1', name: 'product_name', sample: 'Classic Cotton T-Shirt'},
    {id: 'v2', name: 'vendor', sample: 'MyShop'},
    {id: 'v3', name: 'product_type', sample: 'Apparel'},
    {id: 'v4', name: 'collection', sample: 'Summer Collection'},
    {id: 'v5', name: 'price', sample: '$29.99'},
    {id: 'v6', name: 'sku', sample: 'DEMO-001'},
    {id: 'v7', name: 'tags', sample: 'cotton, basics, summer'},
    {id: 'v8', name: 'weight', sample: '0.3 lb'},
    {id: 'v9', name: 'handle', sample: 'classic-cotton-t-shirt'},
    {id: 'v10', name: 'description', sample: 'A soft, breathable cotton tee for everyday wear.'},
];

export const PROFILE_HEADING_STYLE_OPTIONS = [
    {label: 'No heading', value: 'none'},
    {label: 'ALL CAPS heading', value: 'allCaps'},
    {label: 'Sentence case heading', value: 'sentenceCase'},
];

export const PROFILE_WRITING_STYLE_OPTIONS = [
    {label: 'Concise', value: 'Concise'},
    {label: 'Informative', value: 'Informative'},
    {label: 'Feature-Focused', value: 'Feature-Focused'},
    {label: 'Benefit-Driven', value: 'Benefit-Driven'},
    {label: 'Problem-Solution', value: 'Problem-Solution'},
    {label: 'Technical', value: 'Technical'},
    {label: 'Emotional', value: 'Emotional'},
];

export const DEFAULT_PROFILE_SECTION_SETTINGS = {
    title: {
        minChars: 40,
        maxChars: 80,
        defaultTone: 'Professional',
        defaultWritingStyle: 'Concise',
        profileContext: '',
    },
    description: {
        minChars: 150,
        maxChars: 600,
        defaultTone: 'Professional',
        defaultWritingStyle: 'Informative',
        profileContext: '',
    },
    bullets: {
        bulletCount: 5,
        minChars: 80,
        maxChars: 220,
        headingStyle: 'none',
        defaultTone: 'Professional',
        defaultWritingStyle: 'Benefit-Driven',
        profileContext: '',
    },
    faqs: {
        faqCount: 4,
        minQuestionChars: 30,
        maxQuestionChars: 100,
        minAnswerChars: 120,
        maxAnswerChars: 320,
        defaultTone: 'Professional',
        defaultWritingStyle: 'Informative',
        profileContext: '',
    },
};

export const mergeProfileSettings = (settings = {}) => ({
    usecase: settings.usecase || 'Product listing',
    // tone/audience: null = inherit from brand profile, string = override
    toneOverride: settings.toneOverride ?? settings.tone ?? null,
    audienceOverride: settings.audienceOverride ?? settings.audience ?? null,
    enabled: {
        title: settings.enabled?.title ?? true,
        desc: settings.enabled?.desc ?? true,
        bullets: settings.enabled?.bullets ?? true,
        faqs: settings.enabled?.faqs ?? false,
    },
    title: {
        ...DEFAULT_PROFILE_SECTION_SETTINGS.title,
        ...(settings.title || {}),
    },
    description: {
        ...DEFAULT_PROFILE_SECTION_SETTINGS.description,
        ...(settings.description || {}),
    },
    bullets: {
        ...DEFAULT_PROFILE_SECTION_SETTINGS.bullets,
        ...(settings.bullets || {}),
    },
    faqs: {
        ...DEFAULT_PROFILE_SECTION_SETTINGS.faqs,
        ...(settings.faqs || {}),
    },
    color: settings.color || '',
});

// Resolve effective tone/audience from brand + profile
export const resolveProfileTone = (profileSettings, brandProfile) =>
    profileSettings?.toneOverride || (brandProfile?.toneTags?.length ? brandProfile.toneTags.join(', ') : 'Professional');

export const resolveProfileAudience = (profileSettings, brandProfile) =>
    profileSettings?.audienceOverride || brandProfile?.targetAudience || 'general audience';

export const DEFAULT_PROFILES = [
    {
        id: 'prof-1',
        name: 'Product Listing',
        color: C.teal,
        settings: mergeProfileSettings({
            usecase: 'Product listing',
            enabled: {title: true, desc: true, bullets: true},
        }),
    },
    {
        id: 'prof-2',
        name: 'Landing Page',
        color: C.blue,
        settings: mergeProfileSettings({
            usecase: 'Landing page',
            toneOverride: 'Persuasive',
            enabled: {title: true, desc: true, bullets: true},
        }),
    },
    {
        id: 'prof-3',
        name: 'Email Campaign',
        color: C.coral,
        settings: mergeProfileSettings({
            usecase: 'Email newsletter',
            toneOverride: 'Casual',
            audienceOverride: 'existing customers',
            enabled: {title: true, desc: false, bullets: true},
        }),
    },
    {
        id: 'prof-4',
        name: 'LinkedIn Post',
        color: C.purple,
        settings: mergeProfileSettings({
            usecase: 'LinkedIn post',
            toneOverride: 'Punchy',
            audienceOverride: 'B2B buyers, contractors',
            enabled: {title: false, desc: false, bullets: true},
        }),
    },
];

export const TONE_OPTIONS = [
    'Professional',
    'Persuasive',
    'Educational',
    'Punchy',
    'Casual',
    'Empathetic',
];

export const USECASE_OPTIONS = [
    'Product listing',
    'Landing page',
    'Email newsletter',
    'LinkedIn post',
    'Slide deck',
    'Sales pitch',
    'Amazon listing',
    'SEO blog',
];

export const WIZARD_ANGLES = [
    {
        label: 'Key benefit',
        field: 'Key benefit',
        hint: "What's the #1 thing it does for the buyer?",
    },
    {label: 'Material', field: 'Material', hint: 'What is it made of?'},
    {label: 'Design', field: 'Design style', hint: 'How does it look and feel?'},
    {label: 'Installation', field: 'Installation', hint: 'How easy is it to set up?'},
    {label: 'Ideal customer', field: 'Ideal for', hint: 'Who is this perfect for?'},
    {label: 'Warranty', field: 'Warranty', hint: 'What guarantee backs the product?'},
    {label: 'Value', field: 'Value', hint: 'Why is the price justified?'},
    {label: 'Unique edge', field: 'What sets it apart', hint: 'What can competitors not claim?'},
];

export const WIZARD_FRAMINGS = [
    {label: 'Benefit-led', prefix: 'helps', eg: 'helps you ...'},
    {label: 'Feature-led', prefix: 'made with', eg: 'made with ...'},
    {label: 'Problem / solution', prefix: 'no more', eg: 'no more ...'},
    {label: 'Comparison', prefix: 'unlike', eg: 'unlike others ...'},
    {label: 'Social proof', prefix: 'trusted by', eg: 'trusted by ...'},
    {label: 'Action-oriented', prefix: 'get', eg: 'get ... instantly'},
];

export const DESCRIPTION_WIZARD_ANGLES = [
    {
        label: 'Material story',
        prompt: 'Lead with the craftsmanship, finish, and tactile material quality.',
        hint: 'Best when the build and finish are the hero.',
    },
    {
        label: 'Design mood',
        prompt: 'Emphasize the architectural look, silhouette, and overall visual mood.',
        hint: 'Best for style-led listings.',
    },
    {
        label: 'Performance',
        prompt: 'Highlight dependable performance, durability, and day-to-day ease of use.',
        hint: 'Best for practical conversion copy.',
    },
    {
        label: 'Installation',
        prompt: 'Reassure the buyer around fit, compatibility, and installation simplicity.',
        hint: 'Best when setup confidence matters.',
    },
    {
        label: 'Buyer fit',
        prompt: 'Make it clear who this product is ideal for and where it belongs.',
        hint: 'Best for audience-led positioning.',
    },
    {
        label: 'Premium positioning',
        prompt: 'Frame the product as a premium upgrade with justified value.',
        hint: 'Best for elevated tone and pricing support.',
    },
];

export const DESCRIPTION_WIZARD_FRAMINGS = [
    {
        label: 'Editorial',
        prompt: 'Use a refined, design-forward editorial voice.',
        eg: 'Refined, architectural, design-led.',
    },
    {
        label: 'Benefit-led',
        prompt: 'Keep the copy benefit-led and buyer-oriented.',
        eg: 'Focus on what the buyer gains.',
    },
    {
        label: 'Technical credibility',
        prompt: 'Ground the copy in concrete specifications and trusted details.',
        eg: 'Specific, credible, and detail-rich.',
    },
    {
        label: 'Conversion focused',
        prompt: 'Make the copy persuasive and product-listing ready.',
        eg: 'Clear, scannable, conversion-minded.',
    },
    {
        label: 'SEO natural',
        prompt: 'Work important search phrases in naturally without sounding forced.',
        eg: 'Keyword-aware but still human.',
    },
];

let idCounter = 200;

export const uid = () => String(++idCounter);

export const makeRows = (fields) => fields.map((field) => ({id: uid(), field: field.field, kw: field.kw}));

export const randColor = () =>
    [C.teal, C.blue, C.coral, C.amber, C.purple][Math.floor(Math.random() * 5)];

export const delStyle = {
    width: 20,
    height: 20,
    borderRadius: 5,
    border: `1px solid ${C.border}`,
    background: 'transparent',
    color: C.textSoft,
    cursor: 'pointer',
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};
